import React from "react";

export default function Introduction(props) {
    const prefix = props.prefix;
    const headline = props.headline;
    const suffix = props.suffix;

    return(
        <div className='space-y-4'>
            {prefix &&  (<p className='text-lg md:text-2xl'>{prefix}</p>)}
            {headline &&  (<h2 className='headline' dangerouslySetInnerHTML={{__html: headline}}></h2>)}
            {suffix &&  (<p className='text-lg md:text-2xl' dangerouslySetInnerHTML={{__html: suffix}}></p>)}
        </div>
    )
}
